import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--sticky-header"
//
// Keeps the mainContent scroller's scroll-padding-top in sync with the
// rendered height of the sticky header zone, so Turbo's frame autoscroll
// (which scrolls the frame's FIRST CHILD via scrollIntoView) lands the
// first row below the pinned zone instead of behind it. Stickiness itself
// is pure CSS; this controller only manages the autoscroll offset.
//
// Why the SCROLLER and not this.element: scroll-padding must live on the
// scroll container, and a custom property set on this.element (a
// descendant of the scroller) is invisible to it — custom properties
// inherit DOWN only. The var is written on the scroller too, so it also
// inherits down to the frames and feeds the documented scroll-margin
// fallback rule (see the monolith's application.css).
export default class extends Controller {
  static targets = ["zone"]
  static GAP = 8 // breathing room between the stuck zone and the aligned target

  connect() {
    this.scroller = this.element.closest('[data-ui--admin-layout-target="mainContent"]')
    if (!this.hasZoneTarget || !this.scroller) {
      // Fail soft: stickiness is pure CSS; only the offset is lost.
      console.warn("ui--sticky-header: zone target or mainContent scroller not found; offset disabled")
      return
    }
    this.resizeObserver = new ResizeObserver(() => this.sync())
    this.resizeObserver.observe(this.zoneTarget)
    this.sync()
  }

  disconnect() {
    this.resizeObserver?.disconnect()
    if (this.scroller) {
      this.scroller.style.removeProperty("--sticky-header-offset")
      this.scroller.style.removeProperty("scroll-padding-top")
    }
  }

  sync() {
    if (!this.hasZoneTarget || !this.scroller) return
    const height = this.zoneTarget.offsetHeight // border-box: includes border-b
    this.scroller.style.setProperty("--sticky-header-offset", `${height + this.constructor.GAP}px`)
    this.scroller.style.setProperty("scroll-padding-top", "var(--sticky-header-offset)")
  }
}
